import { render } from "./AutoMapping.vue?vue&type=template&id=277b7d2b"
import script from "./AutoMapping.vue?vue&type=script&lang=js"
export * from "./AutoMapping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__